import { useCallback, useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { hasEvaluationOptOut } from '@/helpers/evaluationOptOut/evaluationOptOut'
import { ensureSeonStream, preloadSeonStream } from '@/helpers/seon/stream'
import services from '@/services/services'

import { getSessionMonitoringAuthData } from './helpers'

const useSeonSessionMonitoring = ({ returnPortalId }) => {
  const { fetchData: fetchSessionMonitoringAuth } = useFetch(services.getSessionMonitoringAuth, {
    doInitialRequest: false,
  })

  const ensureSessionMonitoring = useCallback(() => {
    return ensureSeonStream(() => getSessionMonitoringAuthData(fetchSessionMonitoringAuth, returnPortalId))
  }, [fetchSessionMonitoringAuth, returnPortalId])

  useEffect(() => {
    if (hasEvaluationOptOut()) return

    preloadSeonStream()
  }, [])

  useEffect(() => {
    if (hasEvaluationOptOut() || !returnPortalId) return

    ensureSessionMonitoring()
  }, [returnPortalId, ensureSessionMonitoring])
}

export default useSeonSessionMonitoring
